import { Link } from "react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../data";
import { useAction } from "../../components/ui";

/**
 * Zweiter Faktor für Betreiberrechte (0183): Stand und Schalter für das eigene Betreiberkonto. Einschalten geht erst mit einem
 * eingerichteten, bestätigten Faktor und in einer Sitzung mit zweitem Faktor; so sperrt sich niemand aus der Konsole aus.
 */
interface MfaStand { required: boolean; factor_verified: boolean; session_aal2: boolean }

export function ZweiterFaktorBetrieb() {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ["platform_mfa_status"], queryFn: () => api.read<MfaStand>("platform_mfa_status", {}) });
  const { busy, error, attempt } = useAction();
  if (q.isPending || q.error || !q.data) return null;
  const s = q.data;
  const setzen = (an: boolean) => void attempt(`mfa:${an}`, () => api.rpc("platform_mfa_required_set", { p_on: an }),
    an ? "Zweiter Faktor ist jetzt Pflicht für Betreiberrechte." : "")
    .then(() => qc.invalidateQueries({ queryKey: ["platform_mfa_status"] }));
  return (
    <section className="panel stack" aria-labelledby="mfa-betrieb-h">
      <h2 id="mfa-betrieb-h">Zweiter Faktor für Betreiberrechte</h2>
      <p>
        {s.required ? "Pflicht ist an: Die Konsole wirkt nur nach der Anmeldung mit dem zweiten Faktor." : "Pflicht ist aus."}
        {" "}{s.factor_verified ? "Ein zweiter Faktor ist eingerichtet und muss bei Betreiberrechten ohnehin genutzt werden." : "Für dieses Konto ist noch kein zweiter Faktor eingerichtet."}
      </p>
      {!s.factor_verified && <p className="source-note">Zum Einschalten zuerst unter <Link to="/intern/sicherheit">Anmeldung & Sicherheit</Link> eine Authenticator-App einrichten und sich damit neu anmelden.</p>}
      {s.factor_verified && !s.session_aal2 && !s.required && <p className="source-note">Zum Einschalten einmal ab- und mit dem zweiten Faktor wieder anmelden.</p>}
      {error && <p className="tk-error" role="alert">{error}</p>}
      <div className="row">
        {/* 0500: für Admin und Entwicklung Pflicht, ausschalten geht nicht mehr */}
        {s.required
          ? <small className="muted">Die Pflicht gilt für Admin und Entwicklung und lässt sich nicht ausschalten.</small>
          : <button type="button" className="primary" disabled={!!busy || !s.factor_verified || !s.session_aal2} onClick={() => setzen(true)}>Pflicht einschalten</button>}
      </div>
    </section>
  );
}
